module.exports = __webpack_public_path__ + "img/heart-pulse.c80ccf45.svg";